import styled from 'styled-components';

import { zIndexElevatedLayer5 } from '@xingternal/layout-tokens';
import {
  cornerRadiusL,
  motionEasingEnter,
  motionEasingLeave,
  motionTimeL,
  motionTimeS,
  spaceXL,
  xdlColorBackground,
} from '@xingternal/tokens';

type PopUpWindowTransientProps = {
  $noPadding?: boolean;
};

export const popUpWindowDuration = motionTimeL;
export const popUpWindowTransitionName = 'slideFade';

export const PopUpWindow = styled.div<PopUpWindowTransientProps>`
  width: 100vw;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  overflow: auto;
  /*
  We need a z-index below the dimmer
  see: https://source.xing.com/frontends/brewery/blob/7fa60a10aac82cbe669678c2f4af2e2ba8c2bda4/packages/xdl/dimmer/src/dimmer.styles.ts#L17
  */
  z-index: calc(${zIndexElevatedLayer5} - 2);
  outline: 0;
  background-color: ${xdlColorBackground};
  border-radius: ${cornerRadiusL};

  /* CSS Transition animation */
  &.${popUpWindowTransitionName}-enter {
    opacity: 0;
    transform: translateY(${spaceXL});
  }

  &.${popUpWindowTransitionName}-appear {
    opacity: 0;
    transform: translateY(${spaceXL});
  }

  &.${popUpWindowTransitionName}-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition-duration: ${motionTimeS}, ${motionTimeL};
    transition-property: opacity, transform;
    transition-timing-function: ${motionEasingEnter};
  }

  &.${popUpWindowTransitionName}-appear-active {
    opacity: 1;
    transform: translateY(0);
    transition-duration: ${motionTimeS}, ${motionTimeL};
    transition-property: opacity, transform;
    transition-timing-function: ${motionEasingEnter}, ${motionEasingEnter};
  }

  &.${popUpWindowTransitionName}-enter-done {
    opacity: 1;
    transform: translateY(0);
  }

  &.${popUpWindowTransitionName}-appear-done {
    opacity: 1;
    transform: translateY(0);
  }

  &.${popUpWindowTransitionName}-exit {
    opacity: 1;
    transform: translateY(0);
  }

  &.${popUpWindowTransitionName}-exit-active {
    opacity: 0;
    transform: translateY(${spaceXL});
    transition-duration: ${motionTimeL}, ${motionTimeL};
    transition-property: opacity, transform;
    transition-timing-function: ${motionEasingLeave}, ${motionEasingLeave};
  }

  &.${popUpWindowTransitionName}-exit-done {
    opacity: 0;
    transform: translateY(${spaceXL});
  }
`;
